'use client';

import React, { useEffect, useState, useCallback } from 'react';
import Pusher, { Options } from 'pusher-js';

import APP_CONFIG from '@whistle/config';

import { PusherContextValues, PusherProviderProps } from './types';
import { ChannelsProvider } from './ChannelsProvider';

export type PusherOptions = Options;

export const PusherContext = React.createContext<PusherContextValues>({});

export const getConfig = (token: string, company: string) => {
  return {
    cluster: 'us3',
    authEndpoint: `${APP_CONFIG.AUTH_ENDPOINT}/auth/channel?company=${company}`,
    authTransport: 'ajax' as PusherOptions['authTransport'],
    auth: {
      headers: {
        Authorization: token,
      },
    },
  };
};

export const PusherProvider: React.FC<PusherProviderProps> = ({
  company,
  token,
  children,
  ...props
}) => {
  const [client, setClient] = useState<any | undefined>();

  const connect = useCallback(
    (accessToken: string) => {
      if (!Pusher || client !== undefined || !company || !accessToken) {
        return;
      }

      const config: Options = getConfig(accessToken, company);

      setClient(new Pusher(APP_CONFIG.PUSHER.API_KEY, config));
    },
    [client, company],
  );

  useEffect(() => {
    if (!Pusher || client !== undefined || !company || !token) {
      return;
    }

    connect(token);
  }, [connect, client, props, company, token]);

  return (
    <PusherContext.Provider
      value={{
        client,
        setToken: (newToken: string) => {
          connect(newToken);
        },
      }}
      {...props}
    >
      <ChannelsProvider>{children}</ChannelsProvider>
    </PusherContext.Provider>
  );
};
